import { FaEnvelope, FaHouse, FaPhone } from 'react-icons/fa6'
import ContactCard from './ContactCard'

const About = () => {
	return (
		<div className='flex flex-col justify-between gap-12 p-8 lg:p-16 lg:flex-row'>
			<div className='lg:w-1/2'>
				<h3 className='mb-8 font-semibold'>Contact Us</h3>
				<h2 className='mb-12 text-3xl font-bold'>GET IN TOUCH WITH US</h2>
				<p className='w-11/12 mb-12 text-sm leading-6'>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
					eius tempor incididunt ut labore et dolore magna aliqua. Ut enim
					adiqua minim veniam quis nostrud exercitation ullamco
				</p>
				<div className='flex flex-col gap-8'>
					<ContactCard
						icon={<FaHouse />}
						heading={'Our Location'}
						payload={'123 Street, London, UK'}
					/>
					<ContactCard
						icon={<FaPhone />}
						heading={'Phone Number'}
						payload={'9876543210'}
					/>
					<ContactCard
						icon={<FaEnvelope />}
						heading={'Email Address'}
						payload={'nirzonk47@gmail.com'}
					/>
				</div>
			</div>
			<div className='w-full mt-8 lg:mt-0 lg:w-1/2'>
				<div className='relative p-8 bg-white rounded-lg shadow-lg sm:p-12'>
					<form>
						<div className='mb-6'>
							<input
								type='text'
								placeholder='Your Name'
								className='w-full px-4 py-3 text-sm border rounded outline-none border-zinc-300'
							/>
						</div>
						<div className='mb-6'>
							<input
								type='email'
								placeholder='Your Email'
								className='w-full px-4 py-3 text-sm border rounded outline-none border-zinc-300'
							/>
						</div>
						<div className='mb-6'>
							<input
								type='text'
								placeholder='Your Phone'
								className='w-full px-4 py-3 text-sm border rounded outline-none border-zinc-300'
							/>
						</div>
						<div className='mb-6'>
							<textarea
								rows='6'
								placeholder='Your Message'
								className='w-full px-4 py-3 text-sm border rounded outline-none resize-none border-zinc-300'
							></textarea>
						</div>
						<div>
							<button
								type='submit'
								className='w-full p-3 text-white transition border rounded bg-primary border-primary hover:bg-opacity-90'
							>
								Send Message
							</button>
						</div>
					</form>
					<div>
						<span className='absolute -top-10 -right-9 z-[-1]'>
							<svg
								width='100'
								height='100'
								viewBox='0 0 100 100'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									fill-rule='evenodd'
									clip-rule='evenodd'
									d='M0 100C0 44.7715 0 0 0 0C55.2285 0 100 44.7715 100 100C100 100 100 100 0 100Z'
									fill='#3056D3'
								></path>
							</svg>
						</span>
						<span className='absolute -right-10 top-[90px] z-[-1]'>
							<svg
								width='34'
								height='134'
								viewBox='0 0 34 134'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<circle
									cx='31.9993'
									cy='132'
									r='1.66667'
									transform='rotate(180 31.9993 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 31.9993 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 31.9993 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='88'
									r='1.66667'
									transform='rotate(180 31.9993 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 31.9993 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='45'
									r='1.66667'
									transform='rotate(180 31.9993 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='16'
									r='1.66667'
									transform='rotate(180 31.9993 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='59'
									r='1.66667'
									transform='rotate(180 31.9993 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 31.9993 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 31.9993 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='132'
									r='1.66667'
									transform='rotate(180 17.3333 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 17.3333 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 17.3333 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='88'
									r='1.66667'
									transform='rotate(180 17.3333 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 17.3333 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='45'
									r='1.66667'
									transform='rotate(180 17.3333 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='16'
									r='1.66667'
									transform='rotate(180 17.3333 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='59'
									r='1.66667'
									transform='rotate(180 17.3333 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 17.3333 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 17.3333 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='132'
									r='1.66667'
									transform='rotate(180 2.66536 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 2.66536 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 2.66536 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='88'
									r='1.66667'
									transform='rotate(180 2.66536 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 2.66536 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='45'
									r='1.66667'
									transform='rotate(180 2.66536 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='16'
									r='1.66667'
									transform='rotate(180 2.66536 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='59'
									r='1.66667'
									transform='rotate(180 2.66536 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 2.66536 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 2.66536 1.66665)'
									fill='#13C296'
								></circle>
							</svg>
						</span>
						<span className='absolute -left-7 -bottom-7 z-[-1]'>
							<svg
								width='107'
								height='134'
								viewBox='0 0 107 134'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<circle
									cx='104.999'
									cy='132'
									r='1.66667'
									transform='rotate(180 104.999 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 104.999 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 104.999 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='88'
									r='1.66667'
									transform='rotate(180 104.999 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 104.999 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='45'
									r='1.66667'
									transform='rotate(180 104.999 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='16'
									r='1.66667'
									transform='rotate(180 104.999 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='59'
									r='1.66667'
									transform='rotate(180 104.999 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 104.999 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='104.999'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 104.999 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='132'
									r='1.66667'
									transform='rotate(180 90.3333 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 90.3333 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 90.3333 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='88'
									r='1.66667'
									transform='rotate(180 90.3333 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 90.3333 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='45'
									r='1.66667'
									transform='rotate(180 90.3333 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='16'
									r='1.66667'
									transform='rotate(180 90.3333 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='59'
									r='1.66667'
									transform='rotate(180 90.3333 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 90.3333 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='90.3333'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 90.3333 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='132'
									r='1.66667'
									transform='rotate(180 75.6654 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='132'
									r='1.66667'
									transform='rotate(180 31.9993 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 75.6654 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 31.9993 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 75.6654 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 31.9993 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='88'
									r='1.66667'
									transform='rotate(180 75.6654 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='88'
									r='1.66667'
									transform='rotate(180 31.9993 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 75.6654 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 31.9993 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='45'
									r='1.66667'
									transform='rotate(180 75.6654 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='45'
									r='1.66667'
									transform='rotate(180 31.9993 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='16'
									r='1.66667'
									transform='rotate(180 75.6654 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='16'
									r='1.66667'
									transform='rotate(180 31.9993 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='59'
									r='1.66667'
									transform='rotate(180 75.6654 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='59'
									r='1.66667'
									transform='rotate(180 31.9993 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 75.6654 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 31.9993 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='75.6654'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 75.6654 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='31.9993'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 31.9993 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='132'
									r='1.66667'
									transform='rotate(180 60.9993 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='132'
									r='1.66667'
									transform='rotate(180 17.3333 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 60.9993 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 17.3333 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 60.9993 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 17.3333 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='88'
									r='1.66667'
									transform='rotate(180 60.9993 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='88'
									r='1.66667'
									transform='rotate(180 17.3333 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 60.9993 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 17.3333 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='45'
									r='1.66667'
									transform='rotate(180 60.9993 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='45'
									r='1.66667'
									transform='rotate(180 17.3333 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='16'
									r='1.66667'
									transform='rotate(180 60.9993 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='16'
									r='1.66667'
									transform='rotate(180 17.3333 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='59'
									r='1.66667'
									transform='rotate(180 60.9993 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='59'
									r='1.66667'
									transform='rotate(180 17.3333 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 60.9993 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 17.3333 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='60.9993'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 60.9993 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='17.3333'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 17.3333 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='132'
									r='1.66667'
									transform='rotate(180 46.3333 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='132'
									r='1.66667'
									transform='rotate(180 2.66536 132)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 46.3333 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='117.333'
									r='1.66667'
									transform='rotate(180 2.66536 117.333)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 46.3333 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='102.667'
									r='1.66667'
									transform='rotate(180 2.66536 102.667)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='88'
									r='1.66667'
									transform='rotate(180 46.3333 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='88'
									r='1.66667'
									transform='rotate(180 2.66536 88)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 46.3333 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='73.3333'
									r='1.66667'
									transform='rotate(180 2.66536 73.3333)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='45'
									r='1.66667'
									transform='rotate(180 46.3333 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='45'
									r='1.66667'
									transform='rotate(180 2.66536 45)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='16'
									r='1.66667'
									transform='rotate(180 46.3333 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='16'
									r='1.66667'
									transform='rotate(180 2.66536 16)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='59'
									r='1.66667'
									transform='rotate(180 46.3333 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='59'
									r='1.66667'
									transform='rotate(180 2.66536 59)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 46.3333 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='30.6666'
									r='1.66667'
									transform='rotate(180 2.66536 30.6666)'
									fill='#13C296'
								></circle>
								<circle
									cx='46.3333'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 46.3333 1.66665)'
									fill='#13C296'
								></circle>
								<circle
									cx='2.66536'
									cy='1.66665'
									r='1.66667'
									transform='rotate(180 2.66536 1.66665)'
									fill='#13C296'
								></circle>
							</svg>
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default About
